import { gql } from "@apollo/client";

export const GET_PROFESIONAL_CIERRE = gql`
query GetProfesionalCierreRI($idDatosGeneralesRI: Int!) {
    profesionalCierreRI(idDatosGeneralesRI: $idDatosGeneralesRI) {
      apellido,
      nombre,
      matriculaNac,
      matriculaProv,
      fechaCierreRI,
      firmaMedicoStr,
      firmaValidadorStr,
      idEstadoValidacion,
      apellidoModificacion,
      nombreModificacion,
      matriculaNacModificacion,
      matriculaProvModificacion,
      firmaMedicoModificacionStr
    }
  }`;